// @ts-nocheck
import { MOCK, ensureAppStore, switchRole, getSessionState } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { gamesApi } from "@/api/index";
import { pageLoading, pageError, resolvePageHtml } from "@/app/page-runtime";
import "@/pages/dashboard-grid";
import "@/pages/games";
import "@/pages/users";
import "@/pages/templates";
import "@/pages/share-config";
import "@/pages/settings";
import "@/pages/dashboard";
import "@/pages/game-success";
import "@/pages/game-edit";
import "@/pages/packages";
import "@/pages/package-success";
import "@/pages/share-manager";
import "@/pages/analytics";
import "@/pages/sdk";
import "@/pages/sdk-monitor";
import "@/pages/channels";
import "@/pages/admin-games";
import "@/pages/global-stats";

const { $, $$, emptyState, toast } = UI;
declare const Pages: Record<string, any>;
const Pages = (window as any).Pages;

// ============================================================
// EasyShare App · Router + Layout + Role Switch
// 4 大板块导航：Dashboard / 研发工具 / 运营管理 / 管理员功能
// ============================================================

// ---------- 4 板块导航定义 ----------
const NAV_SECTIONS = [
  {
    type: "single",
    key: "dashboard",
    title: "Dashboard",
    icon: "home",
    path: "/",
    desc: "综合数据一览",
    perm: null,
  },
  {
    type: "group",
    key: "dev_tools",
    title: "研发工具",
    icon: "code",
    perm: "dev_tools",
    children: [
      { type: "sub", title: "游戏", items: [
        { key: "games", title: "游戏管理", icon: "gamepad", path: "/dev/games" },
        { key: "game_create", title: "创建游戏", icon: "plus", path: "/dev/games/create", muted: true },
      ]},
      { type: "sub", title: "包体", items: [
        { key: "packages", title: "包体管理", icon: "package", path: "/dev/packages" },
        { key: "package_create", title: "创建包体", icon: "plus", path: "/dev/packages/create", muted: true },
      ]},
      { type: "sub", title: "SDK", items: [
        { key: "sdk_downloads", title: "SDK 下载", icon: "download", path: "/dev/sdk-downloads" },
        { key: "sdk_monitor", title: "SDK 监控", icon: "activity", path: "/dev/sdk-monitor" },
        { key: "sdk_docs", title: "SDK 文档", icon: "book", path: "/dev/sdk-docs" },
        { key: "sdk_debug", title: "SDK 调试工具", icon: "zap", path: "/dev/sdk-debug" },
      ]},
    ],
  },
  {
    type: "group",
    key: "ops",
    title: "运营工具",
    icon: "trendingUp",
    perm: "ops",
    children: [
      { type: "sub", title: "基础数据", items: [
        { key: "analytics_overview", title: "数据概览", icon: "chart", path: "/ops/analytics/overview" },
        { key: "analytics_ltv", title: "LTV分析", icon: "trendingUp", path: "/ops/analytics/ltv" },

        { key: "package_config", title: "包体运营", icon: "package", path: "/ops/package-config" },
      ]},
      { type: "sub", title: "落地页", items: [
        { key: "landing_manage", title: "落地页管理", icon: "globe", path: "/ops/configured-landing-pages" },
        { key: "template_library", title: "落地页模版库", icon: "layers", path: "/ops/template-library" },
        { key: "landing_create", title: "创建落地页", icon: "plus", path: "/ops/share-landing-config", muted: true },
      ]},
      { type: "sub", title: "分享卡片", items: [
        { key: "card_manage", title: "分享卡片管理", icon: "image", path: "/ops/configured-cards" },
        { key: "card_special", title: "渠道特色卡片", icon: "zap", path: "/ops/enhanced-config-beta" },
        { key: "card_create", title: "创建卡片", icon: "plus", path: "/ops/share-card-config", muted: true },
      ]},
      { type: "sub", title: "分享活动", items: [
        { key: "share_activity_manage", title: "分享活动管理", icon: "calendar", path: "/ops/share-config" },
        { key: "analytics_share_details", title: "分享转化漏斗", icon: "database", path: "/ops/analytics/share-details" },
        { key: "analytics_retention", title: "用户留存分析", icon: "activity", path: "/ops/analytics/retention" },
        { key: "share_activity_create", title: "创建活动分享", icon: "plus", path: "/ops/share-config/activity/create", muted: true },
      ]},
      { type: "sub", title: "实验室", items: [
        { key: "share_activity_lab", title: "实验室", icon: "activity", path: "/ops/share-config/lab" },
        { key: "share_activity_lab_analysis", title: "实验报告-转化率", icon: "chart", path: "/ops/share-config/lab/analysis" },
        { key: "share_activity_lab_retention", title: "实验报告-留存率", icon: "trendingUp", path: "/ops/share-config/lab/retention" },
        { key: "share_activity_lab_create", title: "创建实验组", icon: "plus", path: "/ops/share-config/lab/create", muted: true },
      ]},
    ],
  },
  {
    type: "group",
    key: "admin",
    title: "管理员功能",
    icon: "shield",
    perm: "admin",
    children: [
      { type: "sub", title: "总览", items: [
        { key: "admin_overview", title: "管理员总览", icon: "shield", path: "/admin/overview" },
      ]},
      { type: "sub", title: "治理与安全", items: [
        { key: "game_governance", title: "游戏管理", icon: "gamepad", path: "/admin/governance/games" },
        { key: "credentials", title: "凭证与密钥", icon: "key", path: "/admin/security/credentials" },
        { key: "user_roles", title: "用户与角色", icon: "users", path: "/admin/security/users" },
        { key: "audit_logs", title: "审计日志", icon: "fileText", path: "/admin/security/audit-logs" },
      ]},
      { type: "sub", title: "平台接入与能力", items: [
        { key: "sdk_releases", title: "SDK 发布中心", icon: "package", path: "/admin/platform/sdk-releases" },
        { key: "channel_capabilities", title: "渠道能力中心", icon: "globe", path: "/admin/platform/channels" },
        { key: "config_schema", title: "配置模型治理", icon: "database", path: "/admin/platform/config-schema" },
      ]},
      { type: "sub", title: "Share 全局参数", items: [
        { key: "platform_settings", title: "平台参数", icon: "settings", path: "/admin/platform/settings" },
        { key: "admin_share_languages", title: "多语言配置", icon: "globe", path: "/admin/platform/share-languages" },
        { key: "region_country_settings", title: "区域国家配置", icon: "globe", path: "/admin/platform/regions-countries" },
      ]},
      { type: "sub", title: "平台观测", items: [
        { key: "platform_health", title: "平台健康", icon: "activity", path: "/admin/platform/health" },
      ]},
    ],
  },
];

// 角色默认落地页
const ROLE_HOME = {
  sdk_admin: "/admin/overview",
  operator: "/ops/configured-landing-pages",
  developer: "/dev/games",
};

// ---------- 路由表 ----------
const ROUTES = [
  // Dashboard
  { match: /^\/$/, render: () => Pages.dashboard() },

  // 研发工具
  { match: /^\/dev\/games$/, render: () => Pages.gameList() },
  { match: /^\/dev\/games\/create$/, render: () => Pages.gameCreate() },
  { match: /^\/dev\/games\/([^/]+)$/, render: (m) => Pages.gameDetail(m[1]) },
  { match: /^\/dev\/games\/([^/]+)\/credential$/, render: (m) => Pages.gameCredential(m[1]) },
  { match: /^\/dev\/games\/([^/]+)\/edit$/, render: (m) => Pages.gameEdit(m[1]) },
  { match: /^\/dev\/games\/([^/]+)\/packages\/create$/, render: (m) => Pages.packageCreate(m[1]) },
  { match: /^\/dev\/packages$/, render: () => Pages.packageList() },
  { match: /^\/dev\/packages\/create$/, render: () => Pages.packageCreate() },
  { match: /^\/dev\/packages\/([^/]+)\/success$/, render: (m) => Pages.packageSuccess(m[1]) },
  { match: /^\/dev\/sdk-downloads$/, render: () => Pages.sdkDownloads() },
  { match: /^\/dev\/sdk-monitor$/, render: () => Pages.sdkMonitor() },
  { match: /^\/dev\/sdk-docs$/, render: () => Pages.sdkDocs() },
  { match: /^\/dev\/sdk-debug$/, render: () => Pages.sdkDebug() },
  { match: /^\/sdk\/downloads$/, render: () => Pages.sdkDownloads() },
  { match: /^\/sdk\/debug$/, render: () => Pages.sdkDebug() },

  // 运营管理
  { match: /^\/ops\/share-landing-config$/, render: () => Pages.shareLandingConfigList() },
  { match: /^\/ops\/configured-landing-pages$/, render: () => Pages.configuredLandingPages() },
  { match: /^\/ops\/configured-landing-pages\/([^/]+)$/, render: (m) => Pages.configuredLandingPageDetail(m[1]) },
  { match: /^\/ops\/template-library$/, render: () => Pages.templateLibrary() },
  { match: /^\/ops\/template-library\/([^/]+)\/config$/, render: (m) => Pages.landingTemplateConfig(m[1]) },
  { match: /^\/ops\/share-card-config$/, render: () => Pages.shareCardConfig() },
  { match: /^\/ops\/share-languages$/, render: () => Pages.shareLanguages() },
  { match: /^\/ops\/configured-cards$/, render: () => Pages.configuredCards() },
  { match: /^\/ops\/configured-cards\/([^/]+)\/config$/, render: (m) => Pages.cardConfigEditor(m[1]) },
  { match: /^\/ops\/configured-cards\/([^/]+)$/, render: (m) => Pages.configuredCardDetail(m[1]) },
  { match: /^\/ops\/enhanced-config-beta$/, render: () => Pages.enhancedConfigBeta() },
  { match: /^\/ops\/package-config$/, render: () => Pages.packageConfigList() },
  { match: /^\/ops\/package-config\/([^/]+)\/history$/, render: (m) => Pages.packageConfigHistory(m[1]) },
  { match: /^\/ops\/share-config$/, render: () => Pages.shareConfigList() },
  { match: /^\/ops\/share-config\/lab$/, render: () => Pages.shareConfigLab() },
  { match: /^\/ops\/share-config\/lab\/analysis$/, render: () => Pages.shareConfigLabAnalysis() },
  { match: /^\/ops\/share-config\/lab\/retention\/?$/, render: () => Pages.shareConfigLabRetention() },
  { match: /^\/ops\/share-config\/lab\/create$/, render: () => Pages.shareConfigLabCreate() },
  { match: /^\/ops\/share-config\/activity\/create$/, render: () => Pages.activityShareCreate() },
  { match: /^\/ops\/share-config\/activity\/([^/]+)\/edit-flow$/, render: (m) => Pages.activityShareEdit(m[1]) },
  { match: /^\/ops\/share-config\/activity\/([^/]+)\/edit$/, render: (m) => Pages.activityShareDetail(m[1]) },
  { match: /^\/ops\/share-config\/plans\/create$/, render: () => Pages.configPlanEdit("create") },
  { match: /^\/ops\/share-config\/plans\/([^/]+)$/, render: (m) => Pages.configPlanEdit(m[1]) },
  { match: /^\/ops\/share-config\/([^/]+)\/quick$/, render: (m) => Pages.configQuick(m[1]) },
  { match: /^\/ops\/share-config\/([^/]+)\/expert$/, render: (m) => Pages.configExpert(m[1]) },
  { match: /^\/ops\/templates$/, render: () => Pages.templateList() },
  { match: /^\/ops\/templates\/create$/, render: () => Pages.templateEdit("new") },
  { match: /^\/ops\/templates\/([^/]+)$/, render: (m) => Pages.templateEdit(m[1]) },
  { match: /^\/ops\/share-manager$/, render: () => Pages.shareManager() },
  { match: /^\/ops\/analytics$/, render: () => Pages.analyticsOverview() },
  { match: /^\/ops\/analytics\/overview$/, render: () => Pages.analyticsOverview() },
  { match: /^\/ops\/analytics\/ltv$/, render: () => Pages.ltvAnalysis() },
  { match: /^\/ops\/analytics\/share-details$/, render: () => Pages.shareDataDetails() },
  { match: /^\/ops\/analytics\/retention$/, render: () => Pages.activityUserRetentionAnalysis() },
  { match: /^\/ops\/analytics\/share-details\/([^/]+)$/, render: (m) => Pages.shareDataDetailPage(m[1]) },
  { match: /^\/ops\/analytics\/funnel$/, render: () => Pages.funnelAnalysis() },
  { match: /^\/ops\/analytics\/channels$/, render: () => Pages.channelCompare() },
  { match: /^\/ops\/analytics\/trends$/, render: () => Pages.trends() },
  { match: /^\/ops\/analytics\/paths$/, render: () => Pages.userPaths() },
  { match: /^\/ops\/analytics\/export$/, render: () => Pages.dataExport() },

  // 管理员功能
  { match: /^\/admin\/overview$/, render: () => Pages.adminOverview() },
  { match: /^\/admin\/platform\/sdk-releases$/, render: () => Pages.sdkVersions() },
  { match: /^\/admin\/platform\/channels$/, render: () => Pages.channelMgr() },
  { match: /^\/admin\/platform\/channels\/([^/]+)$/, render: (m) => Pages.channelDetail(m[1]) },
  { match: /^\/admin\/platform\/config-schema$/, render: () => Pages.shareModelMap() },
  { match: /^\/admin\/governance\/games$/, render: () => Pages.adminGameGovernance() },
  { match: /^\/admin\/security\/credentials$/, render: () => Pages.settingsApiKeys() },
  { match: /^\/admin\/security\/users$/, render: () => Pages.userList() },
  { match: /^\/admin\/security\/audit-logs$/, render: () => Pages.adminAuditLogs() },
  { match: /^\/admin\/platform\/settings$/, render: () => Pages.settingsSystem() },
  { match: /^\/admin\/platform\/share-languages$/, render: () => Pages.shareLanguages() },
  { match: /^\/admin\/platform\/regions-countries$/, render: () => Pages.regionCountrySettings() },
  { match: /^\/admin\/platform\/health$/, render: () => Pages.globalStats() },
  { match: /^\/admin\/sdk-versions$/, render: () => Pages.sdkVersions() },
  { match: /^\/admin\/share-model$/, render: () => Pages.shareModelMap() },
  { match: /^\/admin\/games$/, render: () => Pages.adminGameGovernance() },
  { match: /^\/admin\/channels$/, render: () => Pages.channelMgr() },
  { match: /^\/admin\/channels\/([^/]+)$/, render: (m) => Pages.channelDetail(m[1]) },
  { match: /^\/admin\/users$/, render: () => Pages.userList() },
  { match: /^\/admin\/global-stats$/, render: () => Pages.globalStats() },
  { match: /^\/admin\/system$/, render: () => Pages.settingsSystem() },

  // 通用：个人设置（顶栏入口）
  { match: /^\/me\/profile$/, render: () => Pages.settingsProfile() },
];

// ---------- 路由 ----------
function getCurrentPath() {
  const hash = location.hash.replace(/^#/, "") || "/";
  return hash.split("?")[0];
}
function getCurrentPathWithQuery() {
  return location.hash.replace(/^#/, "") || "/";
}
function navigate(path) {
  location.hash = path;
}

let renderSeq = 0;

async function renderRoute() {
  const seq = ++renderSeq;
  const fullPath = getCurrentPathWithQuery();
  const path = getCurrentPath();
  const route = ROUTES.find((r) => r.match.test(path));

  $("#page").innerHTML = `<div class="px-8 py-6 w-full max-w-[1920px] mx-auto 2xl:px-10">${pageLoading()}</div>`;

  try {
    await ensureAppStore();
    if (seq !== renderSeq) return;

    let html = "";
    if (!route) {
      html = UI.emptyState({
        icon: "🚧",
        title: "页面建设中",
        desc: `路由 <code class="px-1 bg-ink-100 rounded text-xs">${path}</code> 尚未实现`,
        action: `<button onclick="navigate('/')" class="px-4 py-2 bg-brand-500 text-white rounded-lg text-sm">回到首页</button>`,
      });
    } else {
      const match = path.match(route.match);
      const rendered = route.render(match);
      html = await resolvePageHtml(rendered);
    }

    if (seq !== renderSeq) return;

    $("#page").innerHTML = `<div class="px-8 py-6 w-full max-w-[1920px] mx-auto 2xl:px-10">${html}</div>`;
    $("#page").scrollTop = 0;
    renderSidebar();
    await renderBreadcrumb(fullPath);
    if (window.PageHooks && typeof PageHooks.mounted === "function") {
      PageHooks.mounted(path);
      PageHooks.mounted = null;
    }
  } catch (err) {
    console.error(err);
    if (seq !== renderSeq) return;
    $("#page").innerHTML = `<div class="px-8 py-6 w-full max-w-[1920px] mx-auto 2xl:px-10">${pageError(err)}</div>`;
    renderSidebar();
  }
}

window.navigate = navigate;
window.renderRoute = renderRoute;
window.getCurrentPath = getCurrentPath;
window.getCurrentPathWithQuery = getCurrentPathWithQuery;

// ---------- Sidebar：板块化渲染（商务风） ----------
function renderSidebar() {
  const path = getCurrentPath();
  const role = MOCK.SESSION.currentRole;
  const perms = MOCK.PERMISSIONS[role];

  const html = NAV_SECTIONS.map((section) => {
    if (section.type === "single") {
      const active = path === section.path;
      const ico = Icon[section.icon] ? Icon[section.icon]({ size: 16, color: active ? "#fff" : "#475569", stroke: 2 }) : "";
      return `
        <a href="#${section.path}" class="nav-item flex items-center gap-2.5 px-3 py-2 rounded-md mb-3 ${active ? "active" : "hover:bg-ink-50 text-ink-700"}">
          <span class="nav-ico flex items-center">${ico}</span>
          <div class="flex-1">
            <div class="text-[13px] font-medium">${section.title}</div>
            <div class="text-[10px] ${active ? "opacity-80" : "text-ink-400"}">${section.desc}</div>
          </div>
        </a>
      `;
    }
    if (section.type === "group") {
      if (section.perm && !perms[section.perm]) return "";

      // 渲染单个子项的函数
      const isActiveItem = (c) => path === c.path || (c.key === "share_activity_manage" && /^\/ops\/share-config\/activity\/[^/]+\/(edit|edit-flow)$/.test(path)) || (!["share_activity_manage", "share_activity_lab"].includes(c.key) && path.startsWith(c.path + "/"));
      const renderItem = (c) => {
        const active = isActiveItem(c);
        const ico = Icon[c.icon]
          ? Icon[c.icon]({ size: 14, color: active ? "#1E3A8A" : c.muted ? "#94A3B8" : "#64748B", stroke: 2 })
          : "";
        const textCls = active
          ? ""
          : c.muted
            ? "text-ink-500"
            : "text-ink-700";
        return `
          <a href="#${c.path}" class="nav-sub ${c.muted ? "muted" : ""} flex items-center gap-2.5 px-2.5 py-1.5 rounded-md ${active ? "active" : textCls}">
            <span class="nav-ico flex items-center w-4">${ico}</span>
            <span class="text-[13px]">${c.title}</span>
          </a>
        `;
      };

      // 判断是否使用了子分组（subsection）模式
      const hasSub = section.children.some((c) => c && c.type === "sub");

      let bodyHtml = "";
      if (hasSub) {
        // 过滤出每个 sub 中可见的子项
        const subs = section.children
          .map((sub) => {
            if (!sub || sub.type !== "sub") {
              // 兼容混排的扁平 item
              if (!sub.perm || perms[sub.perm]) return { type: "flat", item: sub };
              return null;
            }
            const items = (sub.items || []).filter((it) => !it.perm || perms[it.perm]);
            if (items.length === 0) return null;
            return { type: "sub", title: sub.title, items };
          })
          .filter(Boolean);
        if (subs.length === 0) return "";

        bodyHtml = subs
          .map((s, idx) => {
            if (s.type === "flat") {
              return `<div class="space-y-0.5 mb-2">${renderItem(s.item)}</div>`;
            }
            const groupActive = s.items.some(isActiveItem);
            return `
              <div class="nav-subgroup ${groupActive ? "active" : ""}">
                <div class="space-y-0.5">
                  ${s.items.map(renderItem).join("")}
                </div>
              </div>
            `;
          })
          .join("");
      } else {
        const visibleChildren = section.children.filter((c) => !c.perm || perms[c.perm]);
        if (visibleChildren.length === 0) return "";
        bodyHtml = `
          <div class="space-y-0.5">
            ${visibleChildren.map(renderItem).join("")}
          </div>
        `;
      }

      const sectionIco = Icon[section.icon] ? Icon[section.icon]({ size: 12, color: "#94A3B8", stroke: 2 }) : "";
      const sectionHeader = `
        <div class="px-3 mb-1.5 flex items-center gap-1.5">
          ${sectionIco}
          <span class="text-[10px] uppercase tracking-[0.1em] font-semibold text-ink-500">${section.title}</span>
          <span class="flex-1 h-px bg-ink-200"></span>
        </div>
      `;
      return `
        <div class="mb-4">
          ${sectionHeader}
          ${bodyHtml}
        </div>
      `;
    }
    return "";
  }).join("");

  $("#sidebar-nav").innerHTML = html;
}

// ---------- Breadcrumb ----------
async function renderBreadcrumb(fullPath) {
  const path = fullPath.split("?")[0];

  // 找到对应导航项构建面包屑
  let crumbs = [["首页", "/"]];
  if (path === "/") {
    crumbs = [["首页"]];
  } else {
    for (const section of NAV_SECTIONS) {
      if (section.type === "single") continue;
      const children = (section.children || []).flatMap((c) => c?.type === "sub" ? (c.items || []) : [c]);
      const child = children.find((c) => path === c.path);
      if (child) {
        crumbs = [["首页", "/"], [section.title], [child.title]];
        break;
      }
    }
  }

  // 处理动态路由
  let m;
  if ((m = path.match(/^\/dev\/games\/([^/]+)$/))) {
    let g = MOCK.GAMES.find((x) => x.id === m[1]);
    if (!g) {
      try { g = (await gamesApi.get(m[1])).data; } catch (_) {}
    }
    crumbs = [["首页", "/"], ["研发工具"], ["游戏管理", "/dev/games"], [g?.name || m[1]]];
  } else if ((m = path.match(/^\/dev\/games\/([^/]+)\/credential$/))) {
    const g = MOCK.GAMES.find((x) => x.id === m[1]);
    crumbs = [["首页", "/"], ["研发工具"], ["游戏管理", "/dev/games"], [g?.name || "?"], ["凭证"]];
  } else if ((m = path.match(/^\/dev\/games\/([^/]+)\/edit$/))) {
    const g = MOCK.GAMES.find((x) => x.id === m[1]);
    crumbs = [["首页", "/"], ["研发工具"], ["游戏管理", "/dev/games"], [g?.name || "?", `/dev/games/${m[1]}`], ["编辑游戏"]];
  } else if ((m = path.match(/^\/dev\/games\/([^/]+)\/packages\/create$/))) {
    const g = MOCK.GAMES.find((x) => x.id === m[1]);
    crumbs = [["首页", "/"], ["研发工具"], ["游戏管理", "/dev/games"], [g?.name || "?", `/dev/games/${m[1]}`], ["创建包体"]];
  } else if ((m = path.match(/^\/dev\/packages\/([^/]+)\/success$/))) {
    let p = MOCK.PACKAGES.find((x) => x.id === m[1]);
    let g = MOCK.GAMES.find((x) => x.id === p?.game_id);
    if (!p) {
      try {
        const cached = JSON.parse(sessionStorage.getItem(`easyshare:newPackageResult:${m[1]}`) || "null");
        p = cached?.package;
        g = cached?.game || g;
      } catch (e) {}
    }
    crumbs = [["首页", "/"], ["研发工具"], ["包体管理", "/dev/packages"], [g?.name || "?"], [p?.name || m[1]], ["创建成功"]];
  } else if ((m = path.match(/^\/ops\/package-config\/([^/]+)\/history$/))) {
    const p = MOCK.PACKAGES.find((x) => x.id === m[1]);
    const g = MOCK.GAMES.find((x) => x.id === p?.game_id);
    crumbs = [["首页", "/"], ["运营管理"], ["包体运营", "/ops/package-config"], [`${g?.name || ""} / ${p?.name || ""}`], ["配置历史"]];
  } else if ((m = path.match(/^\/ops\/share-config\/([^/]+)\/(quick|expert)$/))) {
    const p = MOCK.PACKAGES.find((x) => x.id === m[1]);
    const g = MOCK.GAMES.find((x) => x.id === p?.game_id);
    crumbs = [
      ["首页", "/"],
      ["运营管理"],
      ["分享活动关联", "/ops/share-config"],
      [`${g?.name || ""} / ${p?.name || ""}`],
      [m[2] === "quick" ? "快速配置" : "专家配置"],
    ];
  } else if ((m = path.match(/^\/ops\/template-library\/([^/]+)\/config$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["落地页模版库", "/ops/template-library"], ["配置模版"]];
  } else if (path === "/ops/share-languages") {
    crumbs = [["首页", "/"], ["运营管理"], ["分享卡片"], ["多语言配置"]];
  } else if (path === "/admin/overview") {
    crumbs = [["首页", "/"], ["管理员功能"], ["管理员总览"]];
  } else if (path === "/admin/platform/share-languages") {
    crumbs = [["首页", "/"], ["管理员功能"], ["Share 全局参数", "/admin/platform/settings"], ["多语言配置"]];
  } else if (path === "/admin/platform/regions-countries") {
    crumbs = [["首页", "/"], ["管理员功能"], ["Share 全局参数", "/admin/platform/settings"], ["区域国家配置"]];
  } else if ((m = path.match(/^\/ops\/share-config\/lab\/create$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["实验室", "/ops/share-config/lab"], ["创建实验组"]];
  } else if ((m = path.match(/^\/ops\/share-config\/lab\/analysis$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["实验室", "/ops/share-config/lab"], ["实验报告-转化率"]];
  } else if ((m = path.match(/^\/ops\/share-config\/lab\/retention\/?$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["实验室", "/ops/share-config/lab"], ["实验报告-留存率"]];
  } else if ((m = path.match(/^\/ops\/share-config\/lab$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["实验室"]];
  } else if ((m = path.match(/^\/ops\/share-config\/activity\/create$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["分享活动管理", "/ops/share-config"], ["创建活动分享"]];
  } else if ((m = path.match(/^\/ops\/share-config\/activity\/([^/]+)\/edit-flow$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["分享活动管理", "/ops/share-config"], ["活动详情", `/ops/share-config/activity/${m[1]}/edit`], ["编辑活动"]];
  } else if ((m = path.match(/^\/ops\/share-config\/activity\/([^/]+)\/edit$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["分享活动管理", "/ops/share-config"], ["活动详情"]];
  } else if ((m = path.match(/^\/ops\/share-config\/plans\/(create|[^/]+)$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["分享活动关联", "/ops/share-config"], [m[1] === "create" ? "新建活动关联" : "编辑活动关联"]];
  } else if ((m = path.match(/^\/ops\/analytics\/share-details\/([^/]+)$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["数据分析"], ["分享转化漏斗", "/ops/analytics/share-details"], ["数据详情"]];
  } else if ((m = path.match(/^\/ops\/analytics\/(overview|ltv|share-details|retention|funnel|channels|trends|paths|export)$/))) {
    const subMap = { overview: "数据概览", ltv: "LTV分析", "share-details": "分享转化漏斗", retention: "用户留存分析", funnel: "漏斗分析", channels: "渠道对比", trends: "趋势分析", paths: "用户路径", export: "数据导出" };
    crumbs = [["首页", "/"], ["运营管理"], ["数据分析"], [subMap[m[1]]]];
  } else if ((m = path.match(/^\/ops\/templates\/([^/]+)$/))) {
    crumbs = [["首页", "/"], ["运营管理"], ["分享卡片配置", "/ops/share-card-config"], [m[1] === "new" ? "创建卡片模板" : "编辑卡片模板"]];
  } else if ((m = path.match(/^\/admin\/(?:platform\/channels|channels)\/([^/]+)$/))) {
    const c = MOCK.CHANNELS.find((x) => x.code === m[1]);
    crumbs = [["首页", "/"], ["管理员功能"], ["渠道能力中心", "/admin/platform/channels"], [c?.name || m[1]]];
  } else if (path === "/me/profile") {
    crumbs = [["首页", "/"], ["个人设置"]];
  }

  $("#breadcrumb").innerHTML = crumbs
    .map((c, i) => {
      const isLast = i === crumbs.length - 1;
      const sep = i > 0 ? `<span class="text-ink-300 mx-1">/</span>` : "";
      const inner = c[1]
        ? `<a href="#${c[1]}" class="hover:text-brand-500">${c[0]}</a>`
        : `<span class="${isLast ? "text-ink-900 font-medium" : ""}">${c[0]}</span>`;
      return sep + inner;
    })
    .join("");
}

// ---------- 角色切换 ----------
function renderUserBar() {
  const session = getSessionState();
  const role = session.role || MOCK.ROLES[MOCK.SESSION.currentRole];
  $("#user-name").textContent = role.user;
  $("#user-role").textContent = role.name;
  $("#user-avatar").textContent = role.avatar;
}

function showRoleMenu(e) {
  e.stopPropagation();
  const existing = $("#role-menu");
  if (existing) {
    existing.remove();
    return;
  }
  const currentRole = getSessionState().currentRole || MOCK.SESSION.currentRole;
  const html = `
    <div id="role-menu" class="absolute bottom-16 left-3 bg-white rounded-xl shadow-pop border border-ink-100 w-56 z-30 overflow-hidden">
      <div class="px-3 py-2 text-[10px] uppercase tracking-wide text-ink-300 border-b border-ink-100">切换角色（演示用）</div>
      ${Object.values(MOCK.ROLES)
        .map(
          (r) => `<button data-role="${r.code}" class="role-item w-full text-left px-3 py-2.5 hover:bg-ink-50 flex items-center gap-2 ${r.code === currentRole ? "bg-brand-50" : ""}">
        <div class="w-7 h-7 rounded-full bg-brand-700 flex items-center justify-center text-white text-xs">${r.avatar}</div>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-ink-900">${r.name}</div>
          <div class="text-[10px] text-ink-500 truncate">${r.desc}</div>
        </div>
        ${r.code === currentRole ? '<span class="text-brand-500">✓</span>' : ""}
      </button>`,
        )
        .join("")}
      <div class="border-t border-ink-100">
        <a href="#/me/profile" class="block px-3 py-2 text-xs hover:bg-ink-50 text-ink-700">⚙️ 个人设置</a>
        <button type="button" id="logout-btn" class="w-full text-left px-3 py-2 text-xs hover:bg-danger-50 text-danger-600">退出登录</button>
      </div>
    </div>
  `;
  document.querySelector("aside").insertAdjacentHTML("beforeend", html);
  $$("#role-menu .role-item").forEach((btn) => {
    btn.onclick = async () => {
      const code = btn.dataset.role;
      $("#role-menu")?.remove();
      await switchRole(code);
      renderUserBar();
      const home = ROLE_HOME[code] || "/";
      navigate(home);
      UI.toast(`已切换到「${MOCK.ROLES[code].name}」视角`, "info");
    };
  });
  const logoutBtn = $("#logout-btn");
  if (logoutBtn) {
    logoutBtn.onclick = async (ev) => {
      ev.stopPropagation();
      $("#role-menu")?.remove();
      if (typeof window.logoutEasyShare === "function") {
        await window.logoutEasyShare();
      }
    };
  }
  document.addEventListener("click", () => $("#role-menu")?.remove(), { once: true });
}

// ---------- 启动 ----------
function bootstrap() {
  renderUserBar();
  $("#role-switch").onclick = showRoleMenu;
  if (!location.hash) location.hash = "/";
  window.addEventListener("hashchange", () => { void renderRoute(); });
  void renderRoute();
}

window.PageHooks = {};
export { bootstrap, navigate, renderRoute, getCurrentPath, getCurrentPathWithQuery };
